<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ABdavA/tc-custom/9781488044786.jpg?1708779381512" alt="This image is the cover for the book Sheikh's Royal Baby Revelation, Secret Heirs of Billionaires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sheikh's Royal Baby Revelation, Secret Heirs of Billionaires
      </h1>
      <p class="bookDescription body article font2">
        <b>Abducted alongside a prince, a woman becomes pregnant with his heir and must marry him in this sexy romance from a <i>USA Today</i>–bestselling author</b>.<br/><br/>When desert prince Ashraf was kidnapped alongside geologist Tori, the desperation of their life-threatening situation led to passionate oblivion. Rescued the next day, Ash never knew Tori’s fate . . . but this powerful sheikh never stopped looking for her. Now he’s finally found Tori—and discovered she’s had his son! To claim them, Ashraf’s prepared to make Tori his queen . . . but can he offer more than his royal name? <br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Annie West
      </h2>
      
      <p class="authorDescription body article">Annie has devoted her life to an intensive study of charismatic heroes who cause the best kind of trouble in the lives of their heroines. As a sideline she researches locations for romance, from vibrant cities to desert encampments and fairytale castles. Annie lives in eastern Australia with her hero husband, between sandy beaches and gorgeous wine country. She finds writing the perfect excuse to postpone housework. To contact her or join her newsletter, visit www.annie-west.com&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05b6912e